export const DiccionarioLogin_ES = [
    {
        'codigo': 'ErrorActualizarClave',
        'mensaje': 'Se presentaron problemas al realizar la recuperación de contraseña'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'El campo contraseña está vacío'
    },
    {
        'codigo': 'ErrorEmailNotFound',
        'mensaje': 'No se encontró la cuenta de correo electrónico'
    },
    {
        'codigo': 'ErrorEstLogin',
        'mensaje': 'Se presentaron problemas al iniciar sesión'
    },
    {
        'codigo': 'ErrorGetingDefaultCompany',
        'mensaje': 'Se presentaron problemas al obtener los datos de la compañía'
    },
    {
        'codigo': 'ErrorGetingDefaultCompanyDB',
        'mensaje': 'Se presentaron problemas al obtener los datos de la compañía'
    },
    {
        'codigo': 'ErrorProfLogin',
        'mensaje': 'Se presentaron problemas al iniciar sesión'
    },
    {
        'codigo': 'ErrorUserUnauthorized',
        'mensaje': 'El usuario no se encuentra autorizado, revise sus credenciales'
    },
    {
        'codigo': 'UnauthorizedPass',
        'mensaje': 'El usuario no se encuentra autorizado, revise sus credenciales'
    },
    {
        'codigo': 'UnauthorizedUser',
        'mensaje': 'El usuario no se encuentra autorizado, revise sus credenciales'
    },
    {
        'codigo': 'UserWithoutRoles',
        'mensaje': 'El usuario no tiene permisos definidos'
    },
    {
        'codigo': 'ErrorConfirmPassw',
        'mensaje': 'Se presentaron problemas al realizar la recuperación de contraseña'
    },
    {
        'codigo': 'ChangePasswOK',
        'mensaje': 'Cambio de contraseña realizado correctamente'
    },
    {
        'codigo': 'ErrorEmailVacio',
        'mensaje': 'El campo usuario está vacío'
    },
    {
        'codigo': 'ErrorContrasenaVacio',
        'mensaje': 'El campo contraseña está vacío'
    }, 
];